import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import T from '../../../translate/T'

import { getNotifications, markToRead } from '../../../modules/actions/Notification'

import BoxScroll from '../../atoms/BoxScroll'
import Link from '../../atoms/Link'
import Avatar from '../../atoms/Avatar'
import If from '../../atoms/If'

import style from './style.css'

class UserNotifications extends Component {
    constructor(props) {
        super(props)
        this.handleOver = this.handleOver.bind(this)
        this.handleOut = this.handleOut.bind(this)
    }

    componentWillMount() {
        this.props.getNotifications()
        
        this.interval = setInterval(function() {
            this.props.getNotifications(this.props.notification.startIn)
        }.bind(this), 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    handleOut() {
        clearTimeout(this.timeoutId)
    }

    handleOver(e, item) {
        this.timeoutId = setTimeout(function() {
            this.props.markToRead(item)
        }.bind(this), 1000)
    }

    render() {
        const renderList = () => {
            return this.props.notification.list.map(item => (
                <Link key={item.id} href={item.link} full>
                    <div
                        onMouseOver={(e) => {
                            this.handleOver(e, item.id)
                            }}
                        onMouseOut={this.handleOut}
                        className={`${style.item} ${(item.status === 'send') ? style.unread : ''}`}
                    >
                        <If test={item.image !== ''}>
                            <Avatar style={{
                                float: 'left'
                            }} img={`${window.URL_ASSETS_API}${item.image}`} size='40' />
                            <span className={style.text} dangerouslySetInnerHTML={{__html: item.description}} />
                        </If>

                        <If test={item.image === ''}>
                            <span dangerouslySetInnerHTML={{__html: item.description}} />
                        </If>
                        
                        
                    </div>
                </Link>
            ))
        }

        return (
            <div className={style.boxNotification}>
            <BoxScroll height='400px' auto>
                <div className={style.items}>
                    {
                        (!this.props.notification.unread && this.props.notification.list.length === 0)
                        ? (
                            <div className={style.nothing}>
                                {T.text('without_notification')}
                            </div>
                        )
                        : null
                    }

                    {renderList()}
                </div>
            </BoxScroll>
            </div>
        )
    }
}

const mapStateToProps = state => ({ notification: state.userNotification })
const mapDispatchToProps = dispatch =>
      bindActionCreators({ getNotifications, markToRead }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(UserNotifications)



// WEBPACK FOOTER //
// ./src/components/organisms/UserNotifications/index.js